<template lang="jade">
  a(target="_blank" 
    ":href"="downloadURL") {{ dataset.title }}
</template>

<script>
import _ from 'lodash'
import api from 'src/config/api'

export default {
  data: () => ({}),
  props: {
    dataset: {
      type: Object,
      required: true
    },
    template: {
      type: Object,
      required: true
    }
  },
  computed: {
    // url () {
    //   // let p = this.dataset.queryParameters
    //   // let params = _.reduce(p, (res, val, key) => {
    //   //   res.push(key.concat('=', val))
    //   //   return res
    //   // }, [])
    //   // return this.dataset.url.concat('?', params.join('&'))
    // },
    downloadURL () {
      let data = _.assign({siteId: 'Member'}, this.template, this.dataset)
      let params = _.pick(data, ['siteId', 'workflowId', 'dbWorkflowKey', 'workflowParameters', 'actions', 'openAs'])
      let render = _.template('<%= origin %><%= pathname %>?<%= params %>')
      let url = render({origin: api.http.root,
                        pathname: api.endpoints.data.pdf,
                        params: this.queryString(params) })
      return encodeURI(url)
    }
  },
  methods: {
    queryString (params) {
      return Object.entries(params)
                   .map(this.paramString)
                   .join('&')
    },

    paramString (pair) {
      let [k, v] = pair
      switch (Object.prototype.toString.call(v)) {
        case '[object Object]':
          return this.objParamString(k, v)
        case '[object Array]':
          return `${k}[]=${v[0]}`
        default:
          return `${k}=${v}`
      }
    },

    objParamString (prop, params) {
      return Object.entries(params).map(xs => `${prop}[${xs[0]}]=${xs[1]}`).join('&')
    }
  }
}
</script>



// WEBPACK FOOTER //
// link.vue?f3766700